<template>
  <div>
    <ModalFile
        v-if="selectedImage != null"
        v-show="isModalVisible"
        :selected-image="internalValue[selectedImage]"
        @close="closeModal"
        @validate="validateModal"
    />
    <div class="form-field form-file multiple">
      <div class="form-label" v-if="label">
        <label>{{ label }}</label>
      </div>
      <div class="form-input">
        <div class="form-input-wrapper">

          <div class="form-file-upload" v-if="uniqueId">

            <draggable v-model="internalValue" @start="drag=true" @end="onEnd" :options="{handle:'.drag'}" class="listing">
              <div v-for="(item, index) in internalValue" v-bind:style="{ width: sizeW }" class="item drag" :title="item.original_filename">
                <div class="image">
                  <img v-if="!item.url" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" height="auto"/>
                  <div v-if="item.url"><img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" v-bind:style="{ backgroundImage: 'url(' + item.url + ')' }" height="auto"/></div>
                  <span class="icon icon-icon_picture" v-if="!item.url"></span>
                  <div class="bt-actions">
                    <button class="bt-edit" v-if="item.url" @click="selectImage(index)"><i class="icon icon-icon_pencil"></i></button>
                    <button class="bt-remove" v-if="item.url" @click="remove(index)"><i class="icon icon-icon_close"></i></button>
                  </div>
                </div>
                <div class="name">
                  <input type="text" :value="item.url" :id="'copy_'+index" style="position:absolute;"/>
                  <span>{{ item.original_filename }}</span>
                  <i class="icon icon-icon_tags" @click="copy('copy_'+index)"></i>
                </div>
              </div>
            </draggable>

            <div class="actions">

              <button class="bt-image">
                <input class="input" type="file" :id="uniqueId" @change="upload($event)" multiple="true">
                <i class="icon icon-icon_picture"></i>
                <span>Ajouter des images</span>
              </button>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {Api} from '../../Api.js'
    import ModalFile from './ModalFile.vue'

    export default {
        name: 'Upload',
        components: {ModalFile},
        props: ['value','width','label','callback'],
        data: function () {
            return {
                selectedImage: null,
                isModalVisible: false,
                internalValue: '',
                img: '',
                uniqueId: null
            }
        },
        created: function() {
            let n = Math.floor(Math.random()*11);
            let k = Math.floor(Math.random()* 1000000);
            this.uniqueId = "file-upload-"+String.fromCharCode(n)+k;

            this.internalValue = this.value;
            this.sizeW = this.width ? this.width + "px" : "auto";
            this.get()
        },
        methods: {
            openModal() {
              this.isModalVisible = true
            },
            closeModal() {
              this.isModalVisible = false
            },
            validateModal(image) {
              this.isModalVisible = false
              this.internalValue[this.selectedImage] = image
              console.log("change image to:", image)
            },
            onEnd() {
                this.$emit('input', this.internalValue);
            },
            upload(e){

                this.internalValue = this.internalValue?this.internalValue:[]

                var fileInput = document.getElementById( this.uniqueId );
                var data = new FormData();

                for(var i=0 ; i<fileInput.files.length ; i++){
                    data.append( 'files[]', fileInput.files[i] );
                }

                Api().post('media', data).then((response) => {

                    for(var i=0 ; i<response.data.length ; i++){
                        if( !this.isInArray(response.data[i].id) ){
                            this.internalValue.push( response.data[i] );
                        }
                    }

                    //this.img = response.data[0].url
                    this.$emit('input', this.internalValue);
                })
            },
            isInArray(id){
                let check = false
                for(var i=0 ; i<this.internalValue.length ; i++){
                    if(this.internalValue[i].id == id){
                        check = true
                        break;
                    }
                }
                return check
            },
            remove(index){
              let ask = confirm("Etes-vous certain de vouloir supprimer ce fichier ?");
              if( ask ) {
                this.internalValue.splice(index, 1);
                this.$emit('input', this.internalValue);
              }
            },
            get(){
                if( this.internalValue && this.internalValue.length ){

                    Api().get('media/'+this.internalValue).then((response) => {
                        if( response.data ){
                            this.img = response.data.url
                        }
                    })

                }
            },
            copy: function(id){
                document.getElementById(id).select();
                document.execCommand("copy");
                alert("Copied !")
            },
            selectImage: function(index){
                this.selectedImage = index
                this.openModal();
                return false;
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.get()
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Gallery.vue